  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i 
          [ngClass]="'pi-'+icon"
          class="pi font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">{{title}}</div>
        <div class="text-right mt-2">{{description}}</div>
      </div>      
    </div>
  </div>